<div class="reading-page doc-page" [attr.lang]="lang" [attr.dir]="page?.rtl ? 'rtl' : null">
  <div id="head" class="section-header">
    <h2 class="section-title">{{ page?.title }}</h2>
  </div>
  <app-policy-card [policyBody]="body">
    <!-- Body -->
    <ng-template #body>
      <p class="policy-languages" dir="ltr">
        <ng-container *ngFor="let language of LANGUAGES; let last = last">
          <strong *ngIf="language.code === lang">{{ language.name }}</strong>
          <a *ngIf="language.code !== lang" [routerLink]="language.path" [attr.lang]="language.code">{{ language.name }}</a>
          <span *ngIf="!last" aria-hidden="true"> · </span>
        </ng-container>
      </p>
      <div class="policy-content" [innerHTML]="page?.html"></div>
    </ng-template>
  </app-policy-card>
</div>
